/** @format */

import axios, { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import Citysearch from "../CitySearch/citysearch.component";
import {
  CardsContainer,
  IdxListingContainer,
  LoadingContainer,
  SearchFilterContainer,
} from "./idxListing.style";

import { useFilterContext } from "../../../context/filter.context";
import FilterProperty from "../FilterBox/filter.component";

import NotFound from "../../../images/No result.gif";
import { getLocation } from "./api/geo_location";

import ConvertToCanadianNumber from "../../../utils/New_construction_details/ConvertNumberToDollar.util";
import PropertyCard, {
  PROPERTY_TYPE_CLASSES,
} from "../PropertyCard/PropertyCard.utilComponent";
import { useNavigate } from "react-router-dom";
import PropertyCard1 from "../PropertyCard1/PropertyCard1.utilComponent";

type propertyProps = {
  propertyId: any;
  photos: any[];
  listPrice: number;
  address: string;
  city: string;
  postalCode: string;
  bedroomsTotal: string;
  bathroomsTotal: string;
  transactionType: string;
  cityRegion: string;
  garageSpaces: string;
};
type IdxListingType = {
  type: "template1" | "template3";
  cardType?: PROPERTY_TYPE_CLASSES;
};
export default function IdxListing({ type, cardType }: IdxListingType) {
  const [property, setproperty] = useState([]);
  const [lastPage, setLastPage] = useState(1);
  const [loader, setloader] = useState("loading");
  const [resultCount, setResult] = useState(0);
  const [geoLocation, setGeoLocation] = useState({ latitude: 0, longitude: 0 });
  const Navigate = useNavigate();

  const { state, setProperty } = useFilterContext();

  const {
    city,
    page,
    bathroom,
    bedroom,
    building_status,
    home_type,
    min_price,
    max_price,
    search,
    sortBy,
    sortDir,
    sale_or_lease,
    property_style,
    streetSearch,
    mlsNumber,
  } = state;

  const currentPage = parseInt(page || "1");

  const handleScrollUp = () => window.scrollTo(0, 0);

  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > lastPage) return;
    setProperty("page", newPage.toString());
    handleScrollUp();
  };

  useEffect(() => {
    const FetchLocation = async () => {
      try {
        const Data = await getLocation();
        if (search === "") {
          setGeoLocation({ latitude: Data[0], longitude: Data[1] });
        } else {
          setGeoLocation({ latitude: null, longitude: null });
        }
      } catch (error) {
        throw new Error(error.message);
      }
    };
    FetchLocation();
  }, [search]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    async function fetchData() {
      setloader("loading");
      setproperty([]);
      try {
        let resp: AxiosResponse<any, any>;
        let Mlsproperty = [];

        if (mlsNumber === null) {
          const saleOrLease =
            sale_or_lease === "Sale" ? "For Sale" :
            sale_or_lease === "Lease" ? "For Lease" :
            sale_or_lease;

          resp = await axios.get(
            `https://api.bluebrickglobal.com/api/residential-filter`,
            {
              cancelToken: source.token,
              params: {
                ...(sortDir && { sortDir }),
                ...(search && { city: search }),
                page: currentPage,
                ...(saleOrLease && { sale_or_lease: saleOrLease }),
                ...(home_type && { property_type: home_type }),
                ...(property_style && { property_style }),
                ...(min_price && { min_price }),
                ...(max_price && { max_price }),
                ...(bedroom && { bedrooms_above_grade: bedroom }),
                ...(bathroom && { bathrooms_total: bathroom }),
                ...(sortBy && { sortBy }),
              },
            },
          );
        } else {
          const property = await axios.get(
            `https://valuation.santhoshmathew.com/api/v1/idx-property-details/${mlsNumber}`
          );
          const data = property.data.data;
          Mlsproperty.push(data);
        }

        if (mlsNumber === null) {
          const raw = resp.data;
          const respData = Array.isArray(raw)
            ? raw
            : Array.isArray(raw?.data)
            ? raw.data
            : Array.isArray(raw?.listings)
            ? raw.listings
            : Array.isArray(raw?.properties)
            ? raw.properties
            : [];

          // Try every common pagination envelope shape
          const totalPages =
            raw?.meta?.last_page ??
            raw?.last_page ??
            raw?.pagination?.last_page ??
            raw?.totalPages ??
            raw?.total_pages ??
            null;

          const totalCount =
            raw?.meta?.total ??
            raw?.total ??
            raw?.pagination?.total ??
            raw?.totalCount ??
            null;

          if (totalPages) {
            setLastPage(Number(totalPages));
            setProperty("last_page", String(totalPages));
          } else if (respData.length === 20) {
            // API returned a full page — assume more pages exist
            setLastPage(currentPage + 1);
          } else {
            setLastPage(currentPage);
          }

          setResult(totalCount ?? respData.length);

          setproperty(
            respData.map((item: propertyProps) => ({
              id: item.propertyId,
              img: [...(item.photos ?? [])].sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0)).map((p: any) => p?.url ?? p),
              price: ConvertToCanadianNumber(item.listPrice),
              title: `${item.address} ${item.cityRegion}`,
              bedrooms: item.bedroomsTotal ?? 0,
              bathrooms: item.bathroomsTotal,
              garage: item.garageSpaces ?? 0,
              city: item.city,
              sale_or_lease: item.transactionType,
              redirect: "idxView",
            })),
          );
        } else {
          setResult(1);
          setproperty(
            Mlsproperty.map((item: propertyProps) => ({
              id: item.propertyId,
              img: [...(item.photos ?? [])].sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0)).map((p: any) => p?.url ?? p),
              price: ConvertToCanadianNumber(item.listPrice),
              title: `${item.address} ${item.cityRegion}`,
              bedrooms: item.bedroomsTotal ?? 0,
              bathrooms: item.bathroomsTotal,
              garage: item.garageSpaces ?? 0,
              city: item.city,
              sale_or_lease: item.transactionType,
              redirect: "idxView",
            })),
          );
        }

        setloader("completed");
        handleScrollUp();
      } catch (error) {
        console.error("Error fetching data: ", error);
        setloader("completed");
      }
    }
    fetchData();
    return () => {
      source.cancel("Api call got canceled by cleanup.");
    };
  }, [
    page,
    city,
    bathroom,
    bedroom,
    building_status,
    home_type,
    min_price,
    max_price,
    sortBy,
    sortDir,
    sale_or_lease,
    search,
    property_style,
    geoLocation.latitude,
    geoLocation.longitude,
    mlsNumber,
  ]);

  const renderPagination = () => {
    if (lastPage <= 1) return null;

    const pages = [];
    const createPage = (p: number) => (
      <li key={p}>
        <button
          className={`custom-pagination-btn ${currentPage === p ? "active" : ""}`}
          onClick={() => handlePageChange(p)}
        >
          {p}
        </button>
      </li>
    );

    if (currentPage > 2) {
      pages.push(createPage(1));
      if (currentPage > 3) {
        pages.push(<li key="start-ellipsis"><span className="custom-pagination-ellipsis">…</span></li>);
      }
    }

    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      if (i >= 1 && i <= lastPage) pages.push(createPage(i));
    }

    if (currentPage < lastPage - 1) {
      if (currentPage < lastPage - 2) {
        pages.push(<li key="end-ellipsis"><span className="custom-pagination-ellipsis">…</span></li>);
      }
      pages.push(createPage(lastPage));
    }

    return (
      <ul className="custom-pagination d-flex align-items-center gap-3 mt-3">
        <li>
          <button
            className="custom-pagination-nav"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lt; Prev
          </button>
        </li>
        {pages}
        <li>
          <button
            className="custom-pagination-nav"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === lastPage}
          >
            Next &gt;
          </button>
        </li>
      </ul>
    );
  };

  return (
    <>
      <SearchFilterContainer>
        <Citysearch types="idx" />
        <FilterProperty types="idx" totalCount={resultCount} />
        {/* <button className="button_map" onClick={() => Navigate("../map")}>
          Map Search
        </button> */}
      </SearchFilterContainer>
      <IdxListingContainer>
        {loader === "loading" ? (
          <LoadingContainer>
            <div className="loader"></div>
          </LoadingContainer>
        ) : loader === "completed" && property.length !== 0 ? (
          <CardsContainer>
            {property.map((item) => (
              <PropertyCard1 PropertyData={item} />
            ))}
          </CardsContainer>
        ) : (
          <LoadingContainer>
            <img src={NotFound} alt="Not Found" />
          </LoadingContainer>
        )}
        {mlsNumber === null && renderPagination()}
      </IdxListingContainer>
    </>
  );
}
